import {
  ArrayMaxSize,
  ArrayNotEmpty,
  IsArray,
  IsInt,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';

/**
 * Assegnazione categoria singola o bulk: `ids` con un solo elemento copre il
 * caso singolo, quindi non serve un endpoint separato (pattern
 * `BulkNewsActionDto`/`BulkPartnerActionDto`).
 */
export class BulkUpdateRecipeCategoryDto {
  @IsArray()
  @ArrayNotEmpty()
  @ArrayMaxSize(200)
  @IsString({ each: true })
  ids!: string[];

  /**
   * Tri-state come `UpdateRecipeDto.categoryId`: omesso o `null` rimuove la
   * categoria da tutte le ricette selezionate, un uuid la imposta (il backend
   * rifiuta l'id di un altro tenant).
   */
  @IsOptional()
  // Same persisted-ID boundary as UpdateRecipeDto.categoryId.
  @IsUUID('loose')
  categoryId?: string | null;
}

export class BulkUpdateRecipeCategoryResultDto {
  @IsInt()
  affected!: number;
}
